import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Col, Container, Form, Image, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { actionCommon, actionPatient } from "../../../redux/actions";
import { PiUploadSimple } from "react-icons/pi";
import {
  Buttton,
  CustomDatePicker,
  Inputs,
  Modaal,
  SelectO,
} from "../../../components";
import { useAlert, useToast } from "../../../contexts";

const PersonalInformation = ({ loginData }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showAlert } = useAlert();
  const { showToast } = useToast();
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [previewImage, setPreviewImage] = useState(loginData.profileImage);
  const [dob, setDob] = useState();
  const handleShowModal = (type) => {
    setShowModal(true);
    setModalType(type);
  };
  const [credentials, setCredentials] = useState({
    imgData: "",
    userGuid: loginData.userGuid,
  });

  const [credentials1, setCredentials1] = useState({
    userGuid: loginData.userGuid,
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    userType: loginData.userType,
    isVerified: false,
    isEmailVerified: true,
    isMobileVerified: false,
    languageId: null,
    gender: 1,
    doB: "",
    citizenshipId: null,
    profileImage: "",
    profileImageURL: null,
    profileImagePath: "",
    weight: null,
    height: null,
    occupation: "",
    timezoneGuid: "",
    socialSecurityNumber: "",
    currency: "",
    cancelReason: "",
    preferredLanguageIds: [],
    address: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials1((prevCredentials) => ({
      ...prevCredentials,
      [name]: value,
    }));
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };

      if (name === "socialSecurityNumber") {
        delete updatedErrors.socialSecurityNumber;
      }
      if (name === "address" && value.trim().length >= 5) {
        delete updatedErrors.address;
      }

      if (name === "occupation" && value.length >= 2) {
        delete updatedErrors.occupation;
      }
      if (name === "firstName" && value.length >= 2) {
        delete updatedErrors.firstName;
      }
      if (name === "lastName" && value.length >= 2) {
        delete updatedErrors.lastName;
      }
      if (name === "email" && /\S+@\S+\.\S+/.test(value)) {
        delete updatedErrors.email;
      }

      return updatedErrors;
    });
  };
  const handleSelectChange = (name, selected) => {
    setCredentials1((prevCredentials) => ({
      ...prevCredentials,
      [name]: name === "currency" ? selected.currencyCode : selected.value,
    }));

    if (name === "citizenshipId") {
      setSelectedCitizenshipId(selected);
    } else if (name === "timezoneGuid") {
      setSelectedTimeZoneGuid(selected);
    } else if (name === "currency") {
      setSelectedCurrency1(selected);
    } else if (name === "languageId") {
      setSelectedLanguages(selected);
    }

    if (name === "citizenshipId" && selected) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        citizenshipId: "",
      }));
    }

    if (name === "timezoneGuid" && selected) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        timezoneGuid: "",
      }));
    }

    if (name === "currency" && selected) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        currency: "",
      }));
    }

    if (name === "languageId" && selected) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        languageId: "",
      }));
    }
  };

  useEffect(() => {
    dispatch(actionCommon.getCountry());
    dispatch(actionCommon.getWebsiteLanguageData());
    dispatch(actionCommon.getCurrency());
    dispatch(actionCommon.getTimeZones());
  }, [dispatch]);

  const getCurrencyData = useSelector(
    (state) => state.common.getCurrencyData?.data
  );
  const getWebsiteLanguageData = useSelector(
    (state) => state.common.getWebsiteLanguageData?.data
  );
  const getCountryData = useSelector(
    (state) => state.common.getCountryData?.data
  );
  const getTimeZonesData = useSelector(
    (state) => state.common.getTimeZonesData?.data
  );
  const [options1, setOptions1] = useState([]);
  const [options, setOptions] = useState([]);
  const [options2, setOptions2] = useState([]);
  const [options3, setOptions3] = useState([]);
  const [selectedCurrency1, setSelectedCurrency1] = useState([]);
  const [selectedLanguages, setSelectedLanguages] = useState(null);
  const [selectedCitizenshipId, setSelectedCitizenshipId] = useState(null);
  const [selectedTimeZoneGuid, setSelectedTimeZoneGuid] = useState(null);
  useEffect(() => {
    if (getCurrencyData) {
      const newOption = getCurrencyData.result.map((item) => ({
        value: item.currencyID,
        label: item.currency,
        currencyCode: item.currencyCode,
      }));
      setOptions1(newOption);
    }
  }, [getCurrencyData]);
  useEffect(() => {
    if (getWebsiteLanguageData) {
      const newOption = getWebsiteLanguageData.result.map((item) => ({
        value: item.languageId,
        label: item.languageName,
        abb: item.languageAbbreviation,
      }));
      setOptions(newOption);
    }
  }, [getWebsiteLanguageData]);

  useEffect(() => {
    if (getCountryData) {
      const newOption = getCountryData.result.map((item) => ({
        value: item.countryID,
        label: item.countryName,
      }));
      setOptions2(newOption);
    }
  }, [getCountryData]);

  useEffect(() => {
    if (getTimeZonesData) {
      const newOption = getTimeZonesData.result.map((item) => ({
        value: item.timezoneGuid,
        label: item.displayName,
      }));
      setOptions3(newOption);
    }
  }, [getTimeZonesData]);

  useEffect(() => {
    dispatch(actionPatient.getProfileByUserId(loginData?.userGuid));
  }, [dispatch, loginData]);

  const getProfileByUserIdData = useSelector(
    (state) => state.patient.getProfileByUserIdData?.data
  );

  const uploadProfileImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        setPreviewImage(event.target.result);
        const base64String = event.target.result.replace(
          /^data:image\/[a-zA-Z]+;base64,/,
          ""
        );

        setCredentials((prev) => ({
          ...prev,
          imgData: base64String,
        }));
      };

      reader.readAsDataURL(file);
    }
  };

  const handleSave = () => {
    dispatch(
      actionCommon.profileImage(credentials, (error, response) => {
        if (error) {
          if (error.data) {
            if (error.data.statusCode === 400) {
              if (error.data.error && error.data.error.ValidationErrors) {
                error.data.error.ValidationErrors.forEach((validationError) => {
                  console.error(
                    `${t("Field")}: ${validationError.Field} - ${t(
                      "Message"
                    )}: ${validationError.Message}`
                  );

                  showAlert(
                    "danger",
                    validationError.Message,
                    `${t("Error")} : ${validationError.Field}`
                  );
                });
              } else {
                showAlert(
                  "danger",
                  `${t("Invalid_credentials")}`,
                  `${t("Error")} !`
                );
              }
            } else {
              // showAlert("danger", `${t("unexpected_error")}``${t("Error")} !`);
            }
          }
        } else if (response) {
          if (response.status === 200) {
            showToast(
              t("success"),
              t("doctor.my_profile.profile_image_updated"),
              5000,
              true,
              "top-end toast-success"
            );
            dispatch(actionPatient.getProfileByUserId(loginData?.userGuid));
            setShowModal(false);
          }
        }
      })
    );
  };

  useEffect(() => {
    if (getProfileByUserIdData) {
      const data = getProfileByUserIdData.result;
      setCredentials1((prevCredentials) => ({
        ...prevCredentials,
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        phone: data.phone,
        doB: data.doB,
        gender: data.gender || 2,
        socialSecurityNumber: data.socialSecurityNumber,
        weight: data.weight,
        height: data.height,
        occupation: data.occupation,
        address: data.address,
        preferredLanguageIds: data.preferredLanguageIds,
        timezoneGuid: data.timezoneGuid,
        currency: data.currency,
        isVerified: data.isVerified,
        isEmailVerified: data.isEmailVerified,
        isMobileVerified: data.isMobileVerified,
        languageId: data.languageId,
        citizenshipId: data.citizenshipId,
      }));
      if (data.doB) {
        setDob(new Date(data.doB));
      }

      const selectedCitizenship = options2.find(
        (option) => option.value === data.citizenshipId
      );
      setSelectedCitizenshipId(selectedCitizenship);

      const selectedLanguages1 = options.find(
        (option) => option.value === data.languageId
      );

      setSelectedLanguages(selectedLanguages1);

      const selectedTimeZone = options3.find(
        (option) => option.value === data.timezoneGuid
      );
      setSelectedTimeZoneGuid(selectedTimeZone);

      const selectedCurrency = options1.find(
        (option) => option.currencyCode === data.currency
      );
      setSelectedCurrency1(selectedCurrency);
    }
  }, [getProfileByUserIdData, options, options1, options2, options3]);

  const onSaveNext = () => {
    let newErrors = {};

    if (!credentials1.socialSecurityNumber) {
      newErrors.socialSecurityNumber = t("errors.socialSecurityNumber.error1");
    }
    if (!credentials1.firstName) {
      newErrors.firstName = t("errors.firstName.error1");
    } else if (credentials1.firstName.length < 2) {
      newErrors.firstName = t("errors.firstName.error2");
    }
    if (!credentials1.lastName) {
      newErrors.lastName = t("errors.lastName.error1");
    } else if (credentials1.lastName.length < 2) {
      newErrors.lastName = t("errors.lastName.error2");
    }

    if (!credentials1.doB) {
      newErrors.doB = t("errors.doB.error1");
    }

    if (!credentials1.citizenshipId) {
      newErrors.citizenshipId = t("errors.citizenshipId.error1");
    }

    if (!credentials1.weight) {
      newErrors.weight = t("errors.weight.error1");
    } else if (parseInt(credentials1.weight) <= 0) {
      newErrors.weight = t("errors.weight.error2");
    }

    if (!credentials1.height) {
      newErrors.height = t("errors.height.error1");
    } else if (parseInt(credentials1.height) <= 0) {
      newErrors.height = t("errors.height.error2");
    }

    if (!credentials1.email) {
      newErrors.email = t("errors.email.error1");
    } else if (!/\S+@\S+\.\S+/.test(credentials1.email)) {
      newErrors.email = t("errors.email.error2");
    }

    if (!credentials1.phone) {
      newErrors.phone = t("errors.phone.error1");
    } else if (!/^\d+$/.test(credentials1.phone)) {
      newErrors.phone = t("errors.phone.error2");
    }

    if (!credentials1.occupation) {
      newErrors.occupation = t("errors.occupation.error1");
    } else if (credentials1.occupation.length < 2) {
      newErrors.occupation = t("errors.occupation.error2");
    }

    if (!credentials1.address) {
      newErrors.address = t("errors.address.error1");
    } else if (credentials1.address.trim().length < 5) {
      newErrors.address = t("errors.address.error2");
    }

    if (!credentials1.languageId) {
      newErrors.languageId = t("errors.preferredLanguageIds.error1");
    }

    if (!credentials1.timezoneGuid) {
      newErrors.timezoneGuid = t("errors.timezoneGuid.error1");
    }
    if (!credentials1.currency) {
      newErrors.currency = t("errors.currency.error1");
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      dispatch(
        actionPatient.postSaveProfile(credentials1, (error, response) => {
          if (error) {
            if (error.data) {
              if (error.data.statusCode === 400) {
                if (error.data.error && error.data.error.ValidationErrors) {
                  error.data.error.ValidationErrors.forEach(
                    (validationError) => {
                      console.error(
                        `${t("Field")}: ${validationError.Field} - ${t(
                          "Message"
                        )}: ${validationError.Message}`
                      );

                      showAlert(
                        "danger",
                        validationError.Message,
                        `${t("Error")} : ${validationError.Field}`
                      );
                    }
                  );
                } else {
                  showAlert(
                    "danger",
                    `${t("Invalid_credentials")}`,
                    `${t("Error")} !`
                  );
                }
              } else {
                showAlert(
                  "danger",
                  `${t("unexpected_error")}``${t("Error")} !`
                );
              }
            }
          } else if (response) {
            if (response.status === 200) {
              showToast(
                t("success"),
                t("profile_page.update_success_message"),
                5000,
                true,
                "top-end toast-success"
              );

              const updatedFullName = `${credentials1.firstName} ${credentials1.lastName}`;
              const patientAccess =
                JSON.parse(localStorage.getItem("patient_access")) || {};
              patientAccess.fullName = updatedFullName;
              patientAccess.timeZoneId = selectedTimeZoneGuid.label;
              patientAccess.timezoneGuid = selectedTimeZoneGuid.value;

              if (selectedLanguages) {
                patientAccess.languageId = selectedLanguages.value;
                patientAccess.languageAbb = selectedLanguages.abb;
                localStorage.setItem("i18nextLng", selectedLanguages.abb);
              }

              localStorage.setItem(
                "patient_access",
                JSON.stringify(patientAccess)
              );

              dispatch(actionPatient.getProfileByUserId(loginData?.userGuid));
              navigate("/patient/my-profile/health-information/health-tracking");
            }
          }
        })
      );
    }
  };

  return (
    <>
      <Container fluid className="exado-container1">
        <Row className="exado-row1">
          <Col xs="auto">
            <div className="profile-img-blk">
              <Image
                src={getProfileByUserIdData?.result?.profileImage}
                className="profile-img"
              />
            </div>
          </Col>
          <Col xs="auto" className="exado-col">
            <h3>
              {t("Hello")},{" "}
              {getProfileByUserIdData?.result?.firstName +
                " " +
                getProfileByUserIdData?.result?.lastName}
            </h3>
          </Col>
        </Row>
        <Row className="exado-row1">
          <Col xs="auto">
            <ul className="profile-ul">
              <li
                className="exado-title-six custom-cursor-pointer profile-li"
                onClick={() => handleShowModal("Change-Profile-Picture")}
              >
                {t("doctor.profile_page.Change_Profile_Picture")}
              </li>
              <li className="exado-title-six custom-cursor-pointer profile-li">
                {t("doctor.profile_page.Delete_Account")}
              </li>
              <li className="exado-title-six custom-cursor-pointer profile-li">
                {t("send_otp")}
              </li>
              <li className="exado-title-six custom-cursor-pointer profile-li">
                {t("Edit")} {t("Profile")}
              </li>
            </ul>
          </Col>
        </Row>
        <Row className="exado-row1">
          <Form className="patientInfo-form">
            <Row className="pi-row">
              <Form.Label className="exado-title-six pi-lable">
                {t("Patient.profile_page.personal_info")}
              </Form.Label>
              <Col md={12} className="pi-col">
                <Row>
                  <Inputs.FormInputs
                    label={
                      errors.socialSecurityNumber ? (
                        <span className="error-message">
                          {" "}
                          {errors.socialSecurityNumber}
                        </span>
                      ) : (
                        `${t("social_insurance_number")}`
                      )
                    }
                    name="socialSecurityNumber"
                    value={credentials1.socialSecurityNumber}
                    onChange={handleChange}
                    grpClassname={`form-group ${errors.socialSecurityNumber ? "form-group-error" : ""
                      }`}
                    md={6}
                  // disabled={!isEditVisible}
                  />
                </Row>
              </Col>
              <Col md={6} className="pi-col">
                <Row>
                  <Inputs.FormInputs
                    label={
                      errors.firstName ? (
                        <span className="error-message">
                          {" "}
                          {errors.firstName}
                        </span>
                      ) : (
                        `${t("first_name")}`
                      )
                    }
                    name="firstName"
                    value={credentials1.firstName}
                    onChange={handleChange}
                    grpClassname={`form-group ${errors.firstName ? "form-group-error" : ""
                      }`}
                  // disabled={!isEditVisible}
                  />
                </Row>
              </Col>
              <Col md={6} className="pi-col">
                <Row>
                  <Inputs.FormInputs
                    label={
                      errors.lastName ? (
                        <span className="error-message">
                          {" "}
                          {errors.lastName}
                        </span>
                      ) : (
                        `${t("last_name")}`
                      )
                    }
                    name="lastName"
                    value={credentials1.lastName}
                    onChange={handleChange}
                    grpClassname={`form-group ${errors.lastName ? "form-group-error" : ""
                      }`}
                  // disabled={!isEditVisible}
                  />
                </Row>
              </Col>
            </Row>
            <Row className="pi-row">
              <Col md={6} className="dob-col">
                <Form.Label className="exado-title-six">
                  {t("Date_of_Birth")}
                </Form.Label>

                <fieldset
                  className={`frm-fieldset custom-date-picker ${errors.doB ? "error-date" : ""
                    }`}
                >
                  <legend className="frm-legend">
                    {errors.doB ? (
                      <span className="error-message">{errors.doB}</span>
                    ) : (
                      t("Date_of_Birth")
                    )}
                  </legend>

                  <CustomDatePicker.CustomDatePickerDMY
                    selected={dob}
                    onChange={(date) => {
                      setDob(date);

                      const formattedDate = date
                        ? date.toISOString().split("T")[0] // Extract only YYYY-MM-DD
                        : "";

                      setCredentials1((prevCredentials) => ({
                        ...prevCredentials,
                        doB: formattedDate,
                      }));

                      // Clear previous error
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        doB: "",
                      }));
                    }}
                    placeholderText="DD - MM - YYYY"
                    dateFormat="dd-MM-yyyy"
                    className="customDatePicker"
                  // disabled={!isEditVisible}
                  />
                </fieldset>
              </Col>
              <Col md={6} className="na-col">
                <Form.Label className="exado-title-six">
                  {t("Nationality")}
                </Form.Label>

                <SelectO.SelectO
                  options={options2}
                  onChange={(selected) =>
                    handleSelectChange("citizenshipId", selected)
                  }
                  name="citizenshipId"
                  isSearchable={true}
                  value={selectedCitizenshipId}
                  className={`select1 ${errors.citizenshipId ? "select-border-error" : ""
                    }`}
                  placeholder={t("Select") + " " + t("Nationality")}
                // isDisabled={!isEditVisible}
                />
                {errors.citizenshipId && (
                  <Form.Text className="error-message noVerify">
                    {errors.citizenshipId}
                  </Form.Text>
                )}
              </Col>
            </Row>
            <Row className="pi-row">
              <Form.Label className="exado-title-six">{t("Gender")}</Form.Label>
              <Col className="form-grp-radio-col pi-col">
                <Inputs.CheckRadioInput
                  type="radio"
                  label={t("Female")}
                  name="gender"
                  className="form-grp-radio"
                  checked={credentials1.gender === 2}
                  onChange={() =>
                    setCredentials1({ ...credentials1, gender: 2 })
                  }
                // disabled={!isEditVisible}
                />
                <Inputs.CheckRadioInput
                  type="radio"
                  label={t("Male")}
                  name="gender"
                  className="form-grp-radio"
                  checked={credentials1.gender === 1}
                  onChange={() =>
                    setCredentials1({ ...credentials1, gender: 1 })
                  }
                // disabled={!isEditVisible}
                />
                <Inputs.CheckRadioInput
                  type="radio"
                  label={t("Other")}
                  name="gender"
                  className="form-grp-radio"
                  checked={credentials1.gender === 3}
                  onChange={() =>
                    setCredentials1({ ...credentials1, gender: 3 })
                  }
                // disabled={!isEditVisible}
                />
              </Col>
            </Row>
            <Row className="pi-row">
              <Col md={6}>
                <Inputs.FormInputs
                  placeholder="KG"
                  label={
                    errors.weight ? (
                      <span className="error-message">{errors.weight}</span>
                    ) : (
                      `${t("weight")} (KG)`
                    )
                  }
                  name="weight"
                  value={credentials1.weight}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    setCredentials1({
                      ...credentials1,
                      weight: value ? Number(value) : "",
                    });

                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      weight: "",
                    }));
                  }}
                  grpClassname={`form-group ${errors.weight ? "form-group-error" : ""
                    }`}
                // disabled={!isEditVisible}
                />
              </Col>
              <Col md={6}>
                <Row>
                  <Inputs.FormInputs
                    placeholder="CM"
                    // label={t("phone_number")}
                    label={
                      errors.height ? (
                        <span className="error-message">{errors.height}</span>
                      ) : (
                        `${t("height")} (CM)`
                      )
                    }
                    name="height"
                    value={credentials1.height}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      setCredentials1({
                        ...credentials1,
                        height: value ? Number(value) : "",
                      });
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        height: "",
                      }));
                    }}
                    grpClassname={`form-group ${errors.height ? "form-group-error" : ""
                      }`}
                  // disabled={!isEditVisible}
                  />
                </Row>
              </Col>
            </Row>
            <Row className="pi-row">
              <Form.Label className="exado-title-six pi-lable">
                {t("Patient.profile_page.contact_occupation")}
              </Form.Label>
              <Col md={6} className="pi-col">
                <Inputs.FormInputs
                  label={
                    errors.email ? (
                      <span className="error-message">{errors.email}</span>
                    ) : (
                      t("email") + " " + t("Address")
                    )
                  }
                  name="email"
                  value={credentials1.email}
                  onChange={handleChange}
                  grpClassname={`form-group ${errors.email ? "form-group-error" : ""
                    }`}
                // disabled={!isEditVisible}
                />
              </Col>
              <Col md={6} className="pi-col">
                <Row>
                  <Inputs.FormInputs
                    label={
                      errors.phone ? (
                        <span className="error-message">{errors.phone}</span>
                      ) : (
                        t("phone_number")
                      )
                    }
                    name="phone"
                    value={credentials1.phone}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      setCredentials1({
                        ...credentials1,
                        phone: value,
                      });
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        phone: "",
                      }));
                    }}
                    grpClassname={`form-group ${errors.phone ? "form-group-error" : ""
                      }`}
                  // disabled={!isEditVisible}
                  />
                </Row>
              </Col>
              <Col md={12} className="pi-col">
                <Row>
                  <Col md={6}>
                    <Inputs.FormInputs
                      label={
                        errors.occupation ? (
                          <span className="error-message">
                            {errors.occupation}
                          </span>
                        ) : (
                          t("occupation")
                        )
                      }
                      name="occupation"
                      value={credentials1.occupation}
                      onChange={handleChange}
                      grpClassname={`form-group ${errors.occupation ? "form-group-error" : ""
                        }`}
                    // disabled={!isEditVisible}
                    />
                  </Col>
                </Row>
              </Col>
              <Col md={8} className="pi-col">
                <Row>
                  <Inputs.FormInputs
                    label={
                      errors.address ? (
                        <span className="error-message"> {errors.address}</span>
                      ) : (
                        `${t("generate_invoices.address")}`
                      )
                    }
                    name="address"
                    value={credentials1.address}
                    onChange={handleChange}
                    grpClassname={`form-group ${errors.address ? "form-group-error" : ""
                      }`}
                  // disabled={!isEditVisible}
                  />
                </Row>
              </Col>
              <Col md={4} className="pi-col">
                <Row>
                  <Inputs.FormInputs
                    name="zip"
                    value={credentials.zip}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      setCredentials({
                        ...credentials,
                        zip: value,
                      });

                      if (!value) {
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          zip: t("* Zip code is required"),
                        }));
                      } else {
                        setErrors((prevErrors) => {
                          const { zip, ...rest } = prevErrors;
                          return rest;
                        });
                      }
                    }}
                    maxLength={6}
                    label={
                      errors.zip ? (
                        <span className="error-message">{errors.zip}</span>
                      ) : (
                        "Post Code and City"
                      )
                    }
                    grpClassname={`form-group ${errors.zip ? "form-group-error" : ""
                      }`}
                  // disabled={!isEditVisible}
                  />
                </Row>
              </Col>
            </Row>
            <Row className="pi-row">
              <Form.Label className="exado-title-six pi-lable pi-lable1">
                {t("Patient.profile_page.your_account_settings")}
              </Form.Label>
              <Col className="pi-col">
                <SelectO.SelectO
                  options={options}
                  onChange={(selected) =>
                    handleSelectChange("languageId", selected)
                  }
                  name="languageId"
                  isSearchable={true}
                  value={selectedLanguages}
                  className={`select1 ${errors.languageId ? "select-border-error" : ""
                    }`}
                  placeholder={t("Language")}
                // isDisabled={!isEditVisible}
                />
                {errors.languageId && (
                  <Form.Text className="error-message noVerify">
                    {errors.languageId}
                  </Form.Text>
                )}
              </Col>
              <Col className="pi-col">
                <SelectO.SelectO
                  options={options1}
                  onChange={(selected) =>
                    handleSelectChange("currency", selected)
                  }
                  name="currency"
                  isSearchable={true}
                  value={selectedCurrency1}
                  className={`select1 ${errors.currency ? "select-border-error" : ""
                    }`}
                  placeholder={t("currency")}
                // isDisabled={!isEditVisible}
                />
                {errors.currency && (
                  <Form.Text className="error-message noVerify">
                    {errors.currency}
                  </Form.Text>
                )}
              </Col>
              <Col className="pi-col">
                <SelectO.SelectO
                  options={options3}
                  onChange={(selected) =>
                    handleSelectChange("timezoneGuid", selected)
                  }
                  name="timezoneGuid"
                  isSearchable={true}
                  value={selectedTimeZoneGuid}
                  className={`select1 ${errors.timezoneGuid ? "select-border-error" : ""
                    }`}
                  placeholder={t("Timezone")}
                // isDisabled={!isEditVisible}
                />

                {errors.timezoneGuid && (
                  <Form.Text className="error-message noVerify">
                    {errors.timezoneGuid}
                  </Form.Text>
                )}
              </Col>
            </Row>
          </Form>
        </Row>
      </Container>
      <div className="profile-form-btn-blk">
        <Buttton.Buttton
          children={t("SEND")}
          className=" btn-solid-Aqua_Teal"
          onClick={onSaveNext}
        // disabled={!isEditVisible}
        />
      </div>
      <Modaal.Modaal
        show={showModal}
        onHide={() => setShowModal(false)}
        title={
          <h2 className="exado-title-nine">
            {t("doctor.my_profile.change_profile_picture")}
          </h2>
        }
        bodyContent={
          <>
            <figure className="uploaded-img-figure">
              <Image src={previewImage} className="uploaded-img" />
            </figure>
            <Inputs.UploadFileInput
              accept=".png, .jpg, .jpeg"
              buttonText={
                <>
                  <PiUploadSimple className="me-2" />{" "}
                  {t("doctor.my_profile.upload_image")}
                </>
              }
              onchange={uploadProfileImageChange}
              className="upload-input"
            />
          </>
        }
        footer={
          <>
            <Buttton.Buttton
              children={t("close")}
              className="btn-border-Aqua_Teal"
              onClick={() => setShowModal(false)}
            />
            <Buttton.Buttton
              children={t("save_changes")}
              className="btn-solid-Aqua_Teal"
              onClick={handleSave}
            />
          </>
        }
        centered="true"
        className={
          modalType === "Change-Profile-Picture"
            ? "profile-img-modal"
            : "change-password-modal"
        }
      />
    </>
  );
};

export default PersonalInformation;
